import { mapEntityProperties } from '@/utils/mapEntityProperties'
import { CreateUpdateDistrictEntity } from '../../domain/entities/CreateUpdateDistrictEntity'
import { CreateUpdateDistrictDataModel } from './CreateUpdateDistrictDataModel'

export class CreateUpdateDistrictModel extends CreateUpdateDistrictEntity {
  regionId!: number
  constructor(dataDto: CreateUpdateDistrictEntity) {
    super()
    dataDto.districts = dataDto.districts?.map((district) => {
      const result = district.boundaryData
      if (result) {
        result?.push(district.boundaryData![0])
      }
      return {
        ...district,
        boundaryData: result
      }
    })

    const createUpdateDistrictDataModel = dataDto.districts?.map(
      (district) => new CreateUpdateDistrictDataModel(district)
    )

    mapEntityProperties<CreateUpdateDistrictModel>(this, dataDto, {
      exclude: ['region'],
      map: {
        regionId: dataDto.region?.id,
        districts: createUpdateDistrictDataModel
      }
    })
  }
}
